import BlockyBoldText from "components/custom-texts/blocky-bold-text.tsx";
import { Button } from "react-bootstrap";
import { secondaryColor } from "utils/constants.ts";

interface Props {
  onClick: () => void;
  text?: string;
}

const EnterContestButton = ({ onClick, text = "Enter Contest" }: Props) => {
  const buttonStyles = {
    background: secondaryColor,
    color: "black",
    border: secondaryColor,
    width: "100%",
  };

  return (
    <>
      <Button
        style={buttonStyles}
        onClick={() => {
          onClick();
        }}
        onTouchEnd={(e) => {
          onClick();
          e.preventDefault();
        }}
      >
        <BlockyBoldText style={{fontSize: 16}}>{text}</BlockyBoldText>
      </Button>
    </>
  );
};

export default EnterContestButton;
